import { memo } from "react";
import { selectIsExportApplicationsLoading } from "features/onboarding/selectors";
import { TableToolbar, type TableToolbarProps } from "ui/widgets/Table";

const Toolbar = (props: TableToolbarProps) => (
    <TableToolbar
        {...props}
        selectIsExportLoading={selectIsExportApplicationsLoading}
    />
);

export default memo(Toolbar);
